// ElementOnScreenTrigger.ts
// Mirrors ConneXt v2 EosTrigger: element-on-screen trigger with RepeatableOnArticle + RepeatableOnConversation.
import { BaseTrigger } from "./BaseTrigger";
export class ElementOnScreenTrigger extends BaseTrigger {
    constructor() {
        super(...arguments);
        this.hasActionTriggerLimit = false;
        this.hasChangedVisibility = true;
        this.scrollHandler = null;
    }
    get selector() {
        return this.when.Selector || "";
    }
    init() {
        if (!this.selector)
            return;
        const element = document.querySelector(this.selector);
        if (!element)
            return;
        this.scrollHandler = () => this.eosTrigger(element);
        this.scrollHandler();
        window.addEventListener("resize", this.scrollHandler);
        window.addEventListener("scroll", this.scrollHandler);
    }
    eosTrigger(element) {
        if (this.canTrigger()) {
            if (!this.timer) {
                if (this.checkVisible(element)) {
                    if (this.hasChangedVisibility) {
                        this.startTimer(() => {
                            clearTimeout(this.timer);
                            this.timer = null;
                            this.hasChangedVisibility = false;
                            this.markTriggered();
                            this.actionInstance.execute();
                        });
                    }
                }
                else {
                    this.hasChangedVisibility = true;
                }
            }
        }
        else if (!this.hasActionTriggerLimit) {
            this.hasActionTriggerLimit = true;
        }
    }
    checkVisible(element) {
        const rect = element.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }
    unRegister() {
        super.unRegister();
        if (this.scrollHandler) {
            window.removeEventListener("resize", this.scrollHandler);
            window.removeEventListener("scroll", this.scrollHandler);
        }
    }
}
